import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useBusinessContext } from '../context/BusinessContext';
import { useUser } from '../auth/UserContext';
import { toLang } from './index';

/**
 * Headless: keeps the ADMIN UI language in sync with the logged-in user's
 * personal preference (Dados Pessoais → Idioma). This is the person's own choice
 * and wins over the business language — the business `language` only drives the
 * consumer-facing side (public page / consumer emails), not what the owner sees
 * in the admin. Falls back to the business language so the UI still localizes
 * before the profile loads.
 */
const LanguageSync = () => {
    const { i18n } = useTranslation();
    const { user } = useUser();
    const { selectedBusiness } = useBusinessContext();

    useEffect(() => {
        const pref = user?.language || selectedBusiness?.language;
        if (!pref) return;
        const lng = toLang(pref);
        if (i18n.language !== lng) {
            i18n.changeLanguage(lng);
            try { localStorage.setItem('gs-lang', lng); } catch { /* ignore */ }
        }
    }, [user?.language, selectedBusiness?.language, i18n]);

    return null;
};

export default LanguageSync;
